var _defs, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpPopoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#000;stroke-width:1.2px;}.b{font-size:18px;font-family:SFUIDisplay-Medium, SF UI Display;font-weight:500;letter-spacing:0.04em;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 15,
    cy: 15,
    r: 14.4
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(15 20.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.548,
    y: 0
  }, "?"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpPopoverIcon);
export default __webpack_public_path__ + "static/media/help-popover-icon.ce9178ddce3d2233218492fcb3fe8e43.svg";
export { ForwardRef as ReactComponent };